import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=6a25d65a&scoped=true"
import script from "./couponList.vue?vue&type=script&lang=js"
export * from "./couponList.vue?vue&type=script&lang=js"
import style0 from "./couponList.vue?vue&type=style&index=0&id=6a25d65a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a25d65a",
  null
  
)

export default component.exports